import * as jstz from "jstz";
import { Injectable } from "@angular/core";
import { Http, Response } from "@angular/http";
import { Observable } from "rxjs";

import {
    BASE_CONSTANTS,
    BASE_URLS,
    IUnityProxyQueryRequest,
    IUnityProxyDeleteResponse,
    IUnityProxyQueryResponse,
    IUnityProxyFetchRequest,
    IUnityProxyStatsQueryRequest,
    IUnityProxyLogsQueryRequest,
    IUnityProxyFetchHistoricalResponse,
    IUnityProxyFetchTailResponse
} from "@tci/common";

@Injectable()
export class NgUAPService {
    constructor(
        private http: Http
    ) {}

    public createLogsQuery(input: IUnityProxyLogsQueryRequest): Observable<IUnityProxyQueryResponse> {
        return this.createQuery("/logsQueries", input);
    }

    public getLogsResult(input: IUnityProxyFetchRequest): Observable<IUnityProxyFetchTailResponse | IUnityProxyFetchHistoricalResponse> {
        return this.getResult("/logsQueries", input);
    }

    public deleteLogsQuery(queryId: string): Observable<IUnityProxyDeleteResponse> {
        return this.deleteQuery("/logsQueries", queryId);
    }

    public createStatsQuery(input: IUnityProxyStatsQueryRequest): Observable<IUnityProxyQueryResponse> {
        return this.createQuery("/statsQueries", input);
    }

    public getStatsResult(input: IUnityProxyFetchRequest): Observable<IUnityProxyFetchTailResponse | IUnityProxyFetchHistoricalResponse> {
        return this.getResult("/statsQueries", input);
    }

    public deleteStatsQuery(queryId: string): Observable<IUnityProxyDeleteResponse> {
        return this.deleteQuery("/statsQueries", queryId);
    }

    private createQuery(path: string, input: IUnityProxyQueryRequest): Observable<IUnityProxyQueryResponse> {
        const url = `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.LOGS}${path}`;
        const tz = jstz.determine();

        input.clientTimeZone = tz.name();

        return this
            .http
            .post(url, input)
            .map((res: Response) => res.json() || null)
            .catch(error => {
                console.log(error);
                throw error;
            });
    }

    private getResult(
        path: string,
        input: IUnityProxyFetchRequest
    ): Observable<IUnityProxyFetchTailResponse | IUnityProxyFetchHistoricalResponse> {
        let url = `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.LOGS}${path}/${input.queryId}`;
        url += `?fetchSize=${input.fetchSize}&style=${input.style ? input.style : ""}&startRow=${input.startRow}`;

        return this
            .http
            .get(url)
            .map((res: Response) => res.json() || null)
            .catch(error => {
                console.log(error);
                throw error;
            });
    }

    private deleteQuery(path: string, queryId: string): Observable<IUnityProxyDeleteResponse> {
        const url = `${BASE_URLS.WEBSERVER}${BASE_CONSTANTS.LOGS}${path}/${queryId}`;

        return this
            .http
            .delete(url)
            .map((res: Response) => res.json() || null)
            .catch(error => {
                console.log(error);
                throw error;
            });
    }
}
